import { getItemLocalStorage } from '@at/window-utils/lib/local-storage-utils/local-storage.utils'
import { USER_LOCATION_POSTCODE_STORAGE_KEY } from '@at/window-utils/lib/local-storage-utils/local-storage-keys'

import Cookies from 'js-cookie'

const getPostcodeFromCookie = () => {
    const postcodeValue = !!Cookies.get('postcode') && Cookies.get('postcode')
    return (postcodeValue && postcodeValue.split('=').pop()) || undefined
}

export const getStoredPostcode = () =>
    getItemLocalStorage(USER_LOCATION_POSTCODE_STORAGE_KEY) || getPostcodeFromCookie() || undefined
